// extracted by mini-css-extract-plugin
module.exports = {"new":"GameDetailSkillGamesCard_new__ylUAW","exclusive":"GameDetailSkillGamesCard_exclusive__zX3Em","image":"GameDetailSkillGamesCard_image__MVGv1"};